import axios, { AxiosResponse } from "axios";

export interface Item {
  name: string;
  unit: string;
  sizes: number[];
  expiration_days: number;
}

export interface Items {
  items: [Item];
}

export interface QuantityData {
  date_made: string;
  count: number;
  size: number | null;
}

export interface ItemsData {
  name: string;
  quantities: QuantityData[];
}

export interface FeedbackItem {
  name: string;
  message: string;
}

export interface Feedback {
  items: FeedbackItem[];
}

export function getItems(table: string): Promise<AxiosResponse<Items>> {
  return axios.get(`/api/items?sheet=${table}`);
}

export function updateQuantities(
  sheet: string,
  date: string,
  author: string,
  items: ItemsData[]
): Promise<AxiosResponse<Feedback>> {
  const data = {
    author,
    items,
  };
  return axios.post(`/api/update_quantities?date=${date}&sheet=${sheet}`, data);
}
